<template>
  <section class="guest-home" aria-labelledby="guest-welcome-title">
    <div class="guest-hero">
      <div class="guest-hero__content">
        <div class="guest-eyebrow">Free social fashion game</div>
        <h1 id="guest-welcome-title">Welcome to <span>Sorority Wars!</span></h1>
        <p class="guest-hero__lead">
          Create your signature look, build your circle, and make your name on campus.
          Fabulous fashion is only the beginning.
        </p>

        <div class="guest-actions" aria-label="Get started">
          <router-link class="pink-button guest-action guest-action--primary" :to="{name: 'register'}">
            Start playing free
          </router-link>
          <router-link class="blue-button guest-action" :to="{name: 'login'}">
            Welcome back
          </router-link>
        </div>

        <div class="guest-quick-facts">
          <span>Free to play</span>
          <span>Play in your browser</span>
          <router-link :to="{name: 'Download'}">Installable app</router-link>
        </div>
      </div>

      <div class="guest-hero__visual" aria-hidden="true">
        <div class="guest-icon-frame">
          <img src="/img/icons/icon_512.png" alt="">
        </div>
        <div class="guest-tag guest-tag--fashion">Own the runway</div>
        <div class="guest-tag guest-tag--social">Build your circle</div>
        <div class="guest-tag guest-tag--fight">Rule the campus</div>
      </div>
    </div>

    <div class="guest-game-loop">
      <div class="guest-game-loop__intro">
        <div class="guest-section-label">Your story starts here</div>
        <h2>From first look to campus legend.</h2>
        <p>Every outfit, event, and rivalry moves your sorority story forward.</p>
      </div>

      <ol class="guest-steps">
        <li>
          <span class="guest-step__number">01</span>
          <div>
            <h3>Create your look</h3>
            <p>Collect designer clothes, shoes, handbags, rides, and accessories for your avatar.</p>
          </div>
        </li>
        <li>
          <span class="guest-step__number">02</span>
          <div>
            <h3>Live the social life</h3>
            <p>Take on events, grow your skills, and team up with friends in your house.</p>
          </div>
        </li>
        <li>
          <span class="guest-step__number">03</span>
          <div>
            <h3>Make your reputation</h3>
            <p>Compete on the catwalk, battle rivals, and climb the weekly rankings.</p>
          </div>
        </li>
      </ol>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GuestImproved'
}
</script>

<style scoped>
.guest-home,
.guest-home * {
  box-sizing: border-box;
}

.guest-home {
  width: 100%;
  padding: 5px;
  color: #000;
  text-align: left;
}

.guest-hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(290px, 0.75fr);
  min-height: 390px;
  overflow: hidden;
  background: #fff;
  border: 2px solid #e84063;
  border-radius: 12px;
}

.guest-hero__content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 34px 40px 40px;
}

.guest-eyebrow,
.guest-section-label {
  color: #0b5aa8;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.guest-hero h1 {
  max-width: 610px;
  margin: 8px 0 10px;
  color: #145c89;
  font-size: clamp(34px, 5vw, 58px);
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 0.98;
}

.guest-hero h1 span {
  display: block;
  color: #ad1f51;
}

.guest-hero__lead {
  max-width: 600px;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.55;
}

.guest-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
}

.guest-action {
  min-width: 170px;
  min-height: 46px;
  padding: 9px 16px;
  font-size: 14px;
  text-align: center;
}

.guest-action--primary {
  min-width: 205px;
}

.guest-quick-facts {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin-top: 16px;
  color: #0b5aa8;
  font-size: 12px;
  font-weight: 800;
}

.guest-quick-facts span,
.guest-quick-facts a {
  position: relative;
  padding-left: 11px;
}

.guest-quick-facts span::before,
.guest-quick-facts a::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 6px;
  height: 6px;
  background: #e84063;
  border-radius: 50%;
  content: '';
  transform: translateY(-50%);
}

.guest-quick-facts a {
  text-decoration: underline;
}

.guest-hero__visual {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 390px;
  padding: 34px;
  background: #d1ebf1;
  border-left: 1px solid #238cbd;
}

.guest-hero__visual::before {
  position: absolute;
  inset: 14px;
  border: 1px dashed rgba(11, 90, 168, 0.35);
  border-radius: 10px;
  content: '';
}

.guest-icon-frame {
  position: relative;
  z-index: 1;
  width: min(250px, 78%);
  padding: 9px;
  background: #fff;
  border: 2px solid #e84063;
  border-radius: 24px;
  box-shadow: 7px 7px 0 #238cbd;
  transform: rotate(2deg);
}

.guest-icon-frame img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 17px;
}

.guest-tag {
  position: absolute;
  z-index: 2;
  padding: 7px 10px;
  color: #fff;
  border: 2px solid #fff;
  border-radius: 6px;
  box-shadow: 2px 3px 0 rgba(20, 92, 137, 0.28);
  font-size: 11px;
  font-weight: 800;
}

.guest-tag--fashion {
  top: 38px;
  left: 22px;
  background: #e84063;
  transform: rotate(-3deg);
}

.guest-tag--social {
  top: 92px;
  right: 18px;
  background: #0b5aa8;
  transform: rotate(3deg);
}

.guest-tag--fight {
  right: 26px;
  bottom: 42px;
  background: #ad1f51;
  transform: rotate(-2deg);
}

.guest-game-loop {
  display: grid;
  grid-template-columns: minmax(220px, 0.7fr) minmax(0, 1.3fr);
  gap: 12px;
  margin-top: 5px;
  padding: 14px;
  background: #145c89;
  border: 1px solid #238cbd;
  border-radius: 8px;
}

.guest-game-loop__intro {
  align-self: center;
  padding: 10px 14px 10px 6px;
  color: #fff;
}

.guest-game-loop__intro .guest-section-label {
  color: #ffccd7;
}

.guest-game-loop__intro h2 {
  margin-top: 5px;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.15;
}

.guest-game-loop__intro p {
  margin-top: 7px;
  color: #d1ebf1;
  font-size: 11px;
  line-height: 1.45;
}

.guest-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 5px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.guest-steps li {
  min-width: 0;
  padding: 10px;
  background: #fff;
  border: 1px solid #d1ebf1;
  border-radius: 6px;
}

.guest-step__number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 25px;
  color: #fff;
  background: #e84063;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 800;
}

.guest-steps h3 {
  margin-top: 8px;
  color: #0b5aa8;
  font-size: 13px;
  font-weight: 800;
}

.guest-steps p {
  margin-top: 4px;
  color: #333;
  font-size: 12px;
  line-height: 1.45;
}

@media only screen and (max-width: 840px) {
  .guest-hero {
    grid-template-columns: minmax(0, 1.2fr) minmax(245px, 0.8fr);
  }

  .guest-hero__content {
    padding: 28px 24px 34px;
  }

  .guest-game-loop {
    grid-template-columns: 1fr;
  }

  .guest-game-loop__intro {
    padding: 6px;
  }
}

@media only screen and (max-width: 640px) {
  .guest-hero {
    display: flex;
    flex-direction: column-reverse;
  }

  .guest-hero__visual {
    min-height: 230px;
    padding: 24px;
    border-bottom: 1px solid #238cbd;
    border-left: 0;
  }

  .guest-icon-frame {
    width: 160px;
    border-radius: 18px;
    box-shadow: 5px 5px 0 #238cbd;
  }

  .guest-icon-frame img {
    border-radius: 12px;
  }

  .guest-tag {
    font-size: 11px;
  }

  .guest-tag--fashion {
    top: 22px;
    left: 14px;
  }

  .guest-tag--social {
    top: 64px;
    right: 10px;
  }

  .guest-tag--fight {
    right: 18px;
    bottom: 25px;
  }

  .guest-hero__content {
    align-items: center;
    padding: 24px 16px 28px;
    text-align: center;
  }

  .guest-hero h1 {
    font-size: clamp(34px, 11vw, 46px);
  }

  .guest-hero__lead {
    font-size: 14px;
  }

  .guest-actions {
    width: 100%;
    flex-direction: column;
  }

  .guest-action,
  .guest-action--primary {
    width: 100%;
    min-width: 0;
  }

  .guest-quick-facts {
    justify-content: center;
  }

  .guest-steps {
    grid-template-columns: 1fr;
  }

  .guest-steps li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .guest-steps h3 {
    margin-top: 0;
  }
}
</style>
